import React from 'react';
import * as Sentry from '@sentry/react';

// Test button component to verify Sentry's error tracking
function SentryTestButton() {
  const handleTestError = () => {
    // Send a log before throwing the error
    Sentry.logger.info('User triggered test error', {
      action: 'test_error_button_click',
    });
    throw new Error('This is your first error!');
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h3>Sentry Test Component</h3>
      <button
        onClick={handleTestError}
        style={{
          backgroundColor: '#ff4444',
          color: 'white',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        Break the world
      </button>
      <p style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
        Click this button to test Sentry error tracking
      </p>
    </div>
  );
}

export default SentryTestButton;
